import Vue from "vue";
import Component from "vue-class-component";
import { networkErrorMessage } from "./const";
import { getFirestore, setFirestore } from "@/util/firestore";

/**
 * Firestore コレクション名一覧
 */
export const Collections = {
  /** 職員カレンダー設定 */ StaffCalendarSetting: "staff-calendars",
  /** 職員カレンダー色設定 */ StaffCalendarSetColors:
    "staff-calendars-set-colors",
  /** 訪問へ行く 一時保存データ */ VisitTemp: "visit-temp-datas",
  /** 利用者一覧 検索条件 */ SearchCondPatientList:
    "patientlist-search-conditions",
  /** 訪問へ行く 検索条件 */ SearchCondVisitList: "visitlist-search-conditions",
  /** 記録を提出 検索条件 */ SearchCondRecord2List:
    "record2list-search-conditions",
  /** 24時間体制 検索条件（利用者一覧） */ SearchCondHour24List:
    "hour24list-search-conditions",
  /** ホーム アイテムリスト */ HomeItemList: "home-items",
  /** 共有ファイル登録 設定 */ ShareFileSetting: "share-file-settings",
  /** 共有ファイル(利用者) 検索条件 */ PatientShareFileSetting:
    "patient-share-file-settings",
  /** 24時間体制 検索条件 */ SearchCondFulltime:
    "collection-search-cond-fulltime",
  /** 利用者 お気に入り情報 */ FavoritedPatientIds: "favorited-patient-ids",
  /** 利用者 カレンダー 表示設定 */ PatientCalendarDisplay:
    "patient-calendar-display",
  /** レセプト確定状況一覧情報 */ ReceiptListItems: "receipt-list-items",
  /** 訪問予定管理 絞り込み条件 */ ScheduleSearch: "schedule-search",
  /** サポート 検索条件 */ SupportSearch: "support-search",
  /** 帳票一覧 表示列設定 */ ReportListColumnDisplay:
    "reportlist-column-display",
  /** 帳票 緊急連絡先リスト 前回出力日時 */ EmergencyContactListLastOutputDatetime:
    "emergency-contact-list-last-output",
  /** 「iBow AI自動作成」作成履歴 */ AiGenerateState: "generate-state",
  /** 「iBow AI自動作成」作成オプション */ IbowAiGenerateOption:
    "ibow-ai-generate-option",
  /** お知らせ設定 */ BbsSetting: "bbs-setting",
  /** 傷病名付検索履歴 */ DiseaseHistory: "disease-history",
  /** レセプト事前チェック */ ReceiptPreCheck: "pre-check-same-building-count",
  /** BI)利用者 */ OfficeAggregatePatient: "office-aggregate-parent",
  /** BI)指示書集計 */ OfficeAggregateIndicateNumber:
    "office-aggregate-indicate-number",
  /** BI)看護記録集計 */ OfficeAggregateVisitrecordNumber:
    "office-aggregate-visitrecord-number",
  /** BI)利用者継続期間 */ OfficePatientContinuityRate:
    "office-patient-continuity-rate",
  /** BI)利用者数 */ OfficeAggregatePatientNumber:
    "office-aggregate-patient-number",
  /** BI)レセプト売上 */ OfficeAggregateReceiptSales:
    "office-aggregate-receipt-sales",
  /** BI)勤務売上 */ OfficeAggregateUnitCost: "office-aggregate-unit-cost",
  /** レセプト事前チェック 離脱アラート当日非表示設定 */
  PrecheckAlertSuppress: "precheck-alert-suppress"
} as const;

export type Collection = typeof Collections[keyof typeof Collections];

@Component
export default class FireStoreMixin extends Vue {
  public async getFirestore(collectionId: string, documentId: string) {
    try {
      const data = await getFirestore(collectionId, documentId);
      return { data, error: null };
    } catch (error) {
      await this.$openAlert(networkErrorMessage);
      return { data: null, error };
    }
  }

  public async setFirestore(
    collectionId: string,
    documentId: string,
    data: object
  ) {
    try {
      await setFirestore(collectionId, documentId, data);
      return { error: null };
    } catch (error) {
      await this.$openAlert(networkErrorMessage);
      return { error };
    }
  }
}
